import { render } from "./rank-table.vue?vue&type=template&id=99aa33cc"
import script from "./rank-table.vue?vue&type=script&lang=js"
export * from "./rank-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__